import React from 'react'
import styles from './advice.module.css'

export const Advice = () => {
  return (
    <section className={styles.advice}>
      <p>
        <strong>Te recordamos</strong> que de acuerdo a los terminos y condiciones de <strong className={styles.warning}>Pickwin</strong>, los datos de
        tu identificacion y los que ingreses aqui deben de coincidir con los de tu cuenta en{' '}
        <strong className={styles.warning}>Pickwin</strong>.
      </p>

      <h2>!Recuerda!</h2>

      <p>
        En caso de haber hecho un deposito con tarjeta, <strong>los retiros se tendran que realizar a la ultima
        tarjeta que hayas utilizado para abonar saldo</strong>.
      </p>
    </section>
  )
}